import { render, staticRenderFns } from "./water-consent-profile-edit.vue?vue&type=template&id=acdf4b02&"
import script from "./water-consent-profile-edit.vue?vue&type=script&lang=ts&"
export * from "./water-consent-profile-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports